import { Crest } from './Logo'

/**
 * Visas medan vi väntar på att Firebase ska svara om någon är inloggad.
 * Märket pulserar svagt i stället för en anonym snurra – då känns väntan
 * som en del av appen och inte som att något hängt sig.
 */
export function FullPageSpinner({ label = 'Laddar…' }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-bg"
    >
      <Crest size={64} className="motion-safe:animate-pulse" />
      <span className="text-sm font-medium text-muted">{label}</span>
    </div>
  )
}
